import { BaseLoggingStrategy } from '@/logger/strategies';
import { RemoteLoggingProvider } from '@/logger/providers'
import { LogLevel, LogContext, LoggerConfig, LogEntry } from '@/logger';

export class RemoteLoggingStrategy extends BaseLoggingStrategy {
  constructor(
    private readonly provider: RemoteLoggingProvider,
    config: LoggerConfig
  ) {
    super(config);
  }

  log(level: LogLevel, message: string, context?: LogContext, error?: Error): void {
    if (!this.isEnabled(level)) return;

    const entry: LogEntry = {
      level,
      message,
      context,
      timestamp: new Date(),
      error
    };

    this.provider.send(entry);
  }

  isEnabled(level: LogLevel): boolean {
    return !!(this.config.remoteLogging?.enabled &&
      this.shouldLog(level, this.config.minLogLevel));
  }
}
